import styled from "styled-components";

export const AnimatedBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;

  @keyframes blob {
    0% { transform: translate(0px, 0px) scale(1); }
    33% { transform: translate(30px, -50px) scale(1.1); }
    66% { transform: translate(-20px, 20px) scale(0.9); }
    100% { transform: translate(0px, 0px) scale(1); }
  }

  .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    mix-blend-mode: overlay;
    opacity: 0.1;
    animation: blob 7s infinite;
  }

  .blob-1 {
    top: 0;
    left: 25%;
    width: 24rem;
    height: 24rem;
    background-color: #3b82f6;
    animation-delay: 0s;
  }

  .blob-2 {
    top: 0;
    right: 25%;
    width: 24rem;
    height: 24rem;
    background-color: #a855f7;
    animation-delay: 2s;
  }

  .blob-3 {
    bottom: -8rem;
    left: 33%;
    width: 24rem;
    height: 24rem;
    background-color: #34d399;
    animation-delay: 4s;
  }
`;
